import template from './FormStepsComponent.html';

export default {
  template,

  model: {
    prop: 'currentStep',
    event: 'change',
  },

  props: {
    // This is a proxy for v-model's currentStep value
    currentStep: {
      type: Number,
    },
    steps: {
      type: Array,
      default: () => [
        { title: 'Step 1' },
        { title: 'Step 2' },
        { title: 'Step 3' },
        { title: 'Step 4' },
      ],
    },
    lockSteps: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    currentStep() {
      this.$nextTick(() => {
        let stepEl = $(this.$el).find('.form-steps__col--completed:last-child').last();

        if (!stepEl.length) {
          stepEl = $(this.$el).find('.form-steps__col--current');
        }

        // Scroll step into focus
        $(this.$el).animate({
          scrollLeft: $(stepEl).offset().left - 80,
        });
      });
    },
  },

  methods: {
    getStepStateClass(step) {
      if (step === this.currentStep && step === this.steps.length) {
        return 'form-steps__col--completed';
      }

      if (step === this.currentStep) {
        return 'form-steps__col--current';
      }

      if (step < this.steps.length && step < this.currentStep) {
        return 'form-steps__col--completed';
      }

      return '';
    },
  },
};
